import { FC } from "react";
import { Box, Grid, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import DeleteModalStyle from "./DeleteModalStyle";
import ButtonComponent from "../../components/button/ButtonComponent";
import { useTranslation } from "react-i18next";
interface DeleteModelProps {
  deleteTitle: String;
  handleClose: () => void;
  handleDelete: () => void;
  eventName: String;
  modelDes1?: String;
  modelDes1Note?: String;
  deleteDisabled?: boolean;
}

export const DeleteModal: FC<DeleteModelProps> = ({
  deleteTitle,
  handleClose,
  eventName,
  handleDelete,
  modelDes1,
  modelDes1Note,
  deleteDisabled,
}) => {
  const { t } = useTranslation()
  return (
    <Box>
      <Grid container {...DeleteModalStyle.deletModelMainGrid}>
        <Grid item sm={12} md={12} lg={12} width={"100%"}>
          <Typography sx={{ ...DeleteModalStyle.titleMain }}>
            {deleteTitle}
          </Typography>
          {modelDes1 ? (
            <Typography {...{ ...DeleteModalStyle.modelDes1 }}>
              {modelDes1Note ? (
                <span style={{ fontWeight: 700 }}>{modelDes1Note}</span>
              ) : null}
              {modelDes1}
            </Typography>
          ) : null}
          <Stack {...DeleteModalStyle.deleteModelWrapStack}>
            <ButtonComponent
              text={t("btnText.cancel")}
              variant="outlined"
              onClick={handleClose}
              sx={{ ...DeleteModalStyle.deleteBtnModelCancelSx }}
            />
            <ButtonComponent
              text={t("btnText.delete")}
              sx={{ ...DeleteModalStyle.deleteBtnModelSx, }}
              onClick={handleDelete}
              disabled={deleteDisabled}
            />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};
